import _ from 'lodash'
import axios from "axios";
import stripeObj from '../stripeHandler';

const baseAPI = 'ui/loadup';

const prepareDN = async (dn) => {
    try {
        console.log("prepareDN.consulting", dn)
        const response = await axios.get(baseAPI + '/' + dn)
        console.log("prepareDN.response", response)
        if(_.isObjectLike(response) && response.status)
            return response
    } catch(e){
        console.log(e)
    }
},
offerOptions = [
    {key: 'PosPago', label: 'Suscripción'},
    'PagoAnticipado'
]

async function processOffers(uri){
    let data = [];
    try {
        const response = await axios.get(uri)
        if (response.status){
            data = response.data;
            stripeObj.setStripePublicKey(response.stripePublicKey)
        }
    } catch (e) {
        alert(e)
    }
    return data
}

async function getBundleOffers(){
    return await processOffers('ofertas/getrecargas');
}

async function getOffers() {
    return await processOffers('ofertas/getactive');
}

export {
    baseAPI,
    // offerOptions,
    offerOptions,
    getOffers,
    getBundleOffers,
    prepareDN
}